// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root {
    min-height: 100%;
    margin: 0;
}

/* CI: alle Elemente in normaler Schriftstärke.
   !important, weil JobDisplay.css global geladen wird und
   gleich benannte Klassen (.job-name etc.) mit font-weight 600 hineinleaken. */
.scanner3-container,
.scanner3-container *,
.touch-drag-ghost,
.touch-drag-ghost * {
    font-weight: normal !important;
}

.scanner3-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100dvh;
    padding: 0 20px 20px;
    box-sizing: border-box;
    position: relative;
    background-color: var(--blassgruen);
}

.scanner3-container .scanner-content-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    text-align: center;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 12px 0 calc(24px + env(safe-area-inset-bottom));
    overflow: visible;
    box-sizing: border-box;
}

.scanner3-container .back-arrow {
    position: static !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    margin: 8px 0 12px;
    z-index: 50;
}

/* ===================== V3 FESTE VIEWPORT-HÖHE =====================
   Nur Scanner V3 (eindeutige Klasse, damit V1/V2 unberührt bleiben):
   Der Container füllt exakt den Viewport (position:fixed umgeht das
   body-Padding/height-Chaos), und NUR die Job-Liste scrollt – der
   "Bewerbung absenden"-Footer bleibt immer sichtbar. */
.scanner3-container {
    position: fixed;
    inset: 0;
    overflow: hidden;
}

.scanner3-container .scanner-content-wrapper {
    min-height: 0;
}

.scanner3-container .bewerbung-form {
    height: auto;
    flex: 1 1;
    min-height: 0;
    overflow-y: auto; /* nur die Schicht-Auswahl scrollt, falls sie zu hoch wird */
}

.scanner3-container .job-selection-view {
    height: auto;
    flex: 1 1;
    min-height: 0;
}

.scanner3-container .scrollable-content {
    min-height: 0; /* erlaubt dem Flex-Kind zu schrumpfen -> interner Scroll */
}

.scanner3-container .sticky-header,
.scanner3-container .sticky-footer {
    flex: 0 0 auto; /* Kopf & Footer behalten ihre Höhe, schrumpfen nicht weg */
}

/* ===================== SCAN PAGE ===================== */

.scanner3-container .scan-prompt {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    gap: 0.5rem;
    padding: 2rem 1rem;
}

/* Statisches Banner-Logo wie auf der Web-Startseite, etwas kompakter */
.scanner3-container .scan-logo {
    width: 100%;
    max-width: 340px;
    height: auto;
    aspect-ratio: 363 / 276;
    object-fit: contain;
    margin-bottom: 1rem;
}

.scanner3-container .scan-prompt h1 {
    font-family: 'Staatliches', sans-serif;
    font-size: 3rem;
    color: var(--mittelblau);
    text-transform: uppercase;
    margin: 0;
    padding: 0;
    text-align: center;
}

.scanner3-container .scan-subtitle {
    font-family: 'Circular', sans-serif;
    font-size: 1.3rem;
    color: var(--mittelblau);
    margin: 0 0 1rem;
}

.scanner3-container .scanner-icon {
    font-size: 140px;
    color: var(--orange);
    opacity: 0.9;
}

/* ===================== SHIFT SELECTION ===================== */

.scanner3-container .einheiten-grid {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 24px;
  width: 100%;
  margin-bottom: 20px;
  flex-wrap: wrap;
  padding: 2rem;
}

.scanner3-container .einheiten-day-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
}

.scanner3-container .einheiten-day-group h4 {
  margin-bottom: 8px;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.3rem;
  text-transform: uppercase;
  color: var(--mittelblau);
  text-align: center;
}

.scanner3-container .einheiten-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.scanner3-container .einheit-button {
  padding: 32px 28px;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.5rem;
  text-transform: uppercase;
  text-align: center;
  background-color: var(--orange);
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  color: var(--weiss);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.scanner3-container .einheit-button.inactive {
  background-color: #e3e3d3;
  color: #a7ad94;
  cursor: not-allowed;
  box-shadow: none;
}

/* ===================== APPLICATION FORM ===================== */

.scanner3-container .bewerbung-form {
    width: 100%;
    height: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
}

.scanner3-container .bewerbung-form > h1 {
    font-family: 'Staatliches', sans-serif;
    font-size: 2.4rem;
    color: var(--mittelblau);
    text-transform: uppercase;
    text-align: center;
    padding: 0.5rem 0 1rem;
    margin: 0;
    width: 100%;
}

.scanner3-container .bewerbung-form > p {
    font-family: 'Circular', sans-serif;
    font-size: 1.2rem;
    color: var(--mittelblau);
}

.scanner3-container .job-selection-view {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.scanner3-container .sticky-header {
  padding: 0.5rem 1rem 0.75rem 1rem;
  background-color: var(--blassgruen);
  border-radius: 0 0 20px 20px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
  z-index: 10;
}

.scanner3-container .scrollable-content {
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
  padding: 1rem;
}

.scanner3-container .scrollable-content::after {
    content: '';
    position: sticky;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 60px;
    background: linear-gradient(to bottom, transparent, var(--blassgruen));
    pointer-events: none;
}

.scanner3-container .loading-text {
  font-family: 'Circular', sans-serif;
  font-size: 1.5rem;
  padding: 3rem;
  color: var(--mittelblau);
}

.scanner3-container .sticky-footer {
  padding: 1rem;
  background-color: var(--blassgruen);
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -4px 10px rgba(0,0,0,0.08);
  z-index: 10;
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
}

.scanner3-container .form-actions {
    display: flex;
    gap: 1rem;
    margin: 0;
    width: 100%;
    padding: 0;
    box-sizing: border-box;
    flex-wrap: wrap;
}

/* Primary / secondary buttons */
.scanner3-container .submit-button, .scanner3-container .logout-button {
    flex-grow: 1;
    padding: 18px 24px;
    font-family: 'Staatliches', sans-serif;
    font-size: 1.5rem;
    text-transform: uppercase;
    border: none;
    border-radius: 16px;
    cursor: pointer;
    transition: transform 0.15s ease, opacity 0.2s ease;
}

/* Akzeptfarbe = Orange */
.scanner3-container .submit-button {
    background-color: var(--orange);
    color: var(--weiss);
    box-shadow: 0 4px 12px rgba(243, 146, 0, 0.35);
}

.scanner3-container .submit-button:disabled {
    background-color: rgba(243, 146, 0, 0.4);
    color: #fff;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
}

/* Sekundär = blau, outline */
.scanner3-container .logout-button {
    background-color: transparent;
    color: var(--mittelblau);
    border: 2px solid var(--mittelblau);
}

.scanner3-container .einheit-selection-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    width: 100%;
    min-height: 52px;
}

.scanner3-container .einheit-selection-header h2 {
    margin: 0;
    font-family: 'Staatliches', sans-serif;
    font-size: 1.8rem;
    text-transform: uppercase;
    color: var(--mittelblau);
    text-align: center;
    /* full-width centred; padding keeps long titles clear of the back button */
    padding: 0 3.5rem;
}

/* Absolutely positioned so it never shifts the centred heading */
.scanner3-container .back-to-einheit-button {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background: var(--weiss);
    border: 2px solid var(--mittelblau);
    color: var(--mittelblau);
    font-size: 1.6rem;
    cursor: pointer;
    padding: 0.5rem 1rem;
    line-height: 1;
    border-radius: 14px;
    transition: background-color 0.2s, transform 0.15s;
    display: flex;
    align-items: center;
}

.scanner3-container .status-bar {
  width: 100%;
  padding: 0;
  margin-bottom: 0;
}

.scanner3-container .status-bar p {
  margin: 0 0 0.5rem 0;
  font-size: 1.2rem;
}

/* ===================== JOB TILES ===================== */

.scanner3-container .job-tiles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
  width: 100%;
  padding-bottom: 3rem;
  box-sizing: border-box;
}

.scanner3-container .job-tile {
  position: relative;
  background-color: var(--weiss);
  border: 3px solid transparent;
  border-radius: 18px;
  padding: 1.25rem 1rem;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  text-align: center;
}

/* Ausgewählt = oranger Akzent */
.scanner3-container .job-tile.selected {
  border-color: var(--orange);
  background-color: rgba(243, 146, 0, 0.12);
  box-shadow: 0 6px 16px rgba(243, 146, 0, 0.3);
  transform: translateY(-2px);
}

.scanner3-container .job-tile.disabled {
  background-color: #f0f1e8;
  opacity: 0.5;
  cursor: not-allowed;
  border-color: transparent;
  transform: none;
  box-shadow: none;
}

.scanner3-container .job-tile .job-name {
  font-family: 'Staatliches', sans-serif;
  font-size: 1.6rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  color: var(--mittelblau);
}

.scanner3-container .job-tile .job-slots {
  font-family: 'Circular', sans-serif;
  font-size: 1rem;
  color: var(--mittelblau);
  margin: 0;
  background-color: var(--hellgruen);
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
}

/* ===================== PRIORITY SLOTS ===================== */

.scanner3-container .priority-slots-header {
  text-align: center;
  margin-bottom: 0.5rem;
}

.scanner3-container .priority-slots-header h3 {
  margin: 0 0 0.25rem 0;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.6rem;
  line-height: 1.1;
  text-transform: uppercase;
  color: var(--mittelblau);
  text-align: center;
}

.scanner3-container .priority-slots-header .drag-hint {
  font-family: 'Circular', sans-serif;
  text-transform: none;
  font-size: 1rem;
  color: var(--mittelblau);
}

.scanner3-container .priority-slots-header p {
  margin: 0;
  font-family: 'Circular', sans-serif;
  font-size: 1.1rem;
  color: var(--mittelblau);
}

.scanner3-container .priority-slots-container {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background-color: var(--hellgruen);
  border-radius: 18px;
  margin-bottom: 0.6rem;
  width: 100%;
  box-sizing: border-box;
}

.scanner3-container .priority-slot {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem;
  border-radius: 14px;
  min-height: 64px;
  transition: transform 120ms cubic-bezier(0.25, 0.8, 0.25, 1),
              background-color 120ms ease-out,
              box-shadow 120ms ease-out,
              opacity 120ms ease-out;
  position: relative;
  will-change: transform;
  /* Claim the touch gesture so the browser never tries to scroll/zoom mid-drag */
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
}

.scanner3-container .priority-slot.empty {
  background-color: rgba(255, 255, 255, 0.55);
  border: 2px dashed var(--primary-dark);
  justify-content: center;
  color: var(--primary-dark);
}

/* Gefüllt = oranger Akzent */
.scanner3-container .priority-slot.filled {
  background-color: var(--weiss);
  border: 2px solid var(--orange);
  cursor: grab;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

.scanner3-container .priority-slot.filled:active {
  cursor: grabbing;
}

.scanner3-container .priority-slot-number {
  font-family: 'Staatliches', sans-serif;
  font-size: 1.4rem;
  color: var(--primary-dark);
  margin-right: 0.5rem;
}

.scanner3-container .priority-slot.filled .priority-slot-number {
  color: var(--orange);
}

.scanner3-container .priority-slot-name {
  flex-grow: 1;
  text-align: center;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.2rem;
  color: var(--mittelblau);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scanner3-container .priority-slot.empty .priority-slot-name {
  color: var(--primary-dark);
}

.scanner3-container .drag-handle {
  font-size: 1.5rem;
  color: var(--orange);
  cursor: grab;
  margin-left: 0.5rem;
}

/* The lifted card is the floating ghost; the source slot becomes a calm,
   same-size placeholder so the ghost can snap back into it seamlessly.
   We dim the whole slot (instead of hiding its children) so that even if a
   drag were ever to end unexpectedly, the tile can never become invisible. */
.scanner3-container .priority-slot.dragging {
  background-color: rgba(243, 146, 0, 0.08);
  border: 2px dashed var(--orange);
  box-shadow: none;
  opacity: 0.4;
  transform: none;
}

/* Floating clone that follows the finger. transition:none keeps movement
   locked 1:1 to the finger (the clone inherits .priority-slot's transition
   otherwise); the drop-snap sets its own transition inline. */
.touch-drag-ghost {
  box-shadow: 0 12px 24px rgba(72, 80, 40, 0.28), 0 6px 8px rgba(0,0,0,0.18);
  transition: none;
  will-change: transform;
}

.scanner3-container .priority-badge {
  position: absolute;
  top: -10px;
  left: -10px;
  background-color: var(--orange);
  color: white;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Staatliches', sans-serif;
  font-size: 1.4rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.25);
}

/* ===================== CANCEL DIALOG ===================== */

.scanner3-container .cancel-confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(72, 80, 40, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.scanner3-container .cancel-confirm-dialog {
    background-color: white;
    padding: 2.5rem;
    border-radius: 24px;
    box-shadow: 0 8px 28px rgba(0,0,0,0.25);
    text-align: center;
    width: 90%;
    max-width: 500px;
}

.scanner3-container .cancel-confirm-dialog h2 {
    font-family: 'Staatliches', sans-serif;
    font-size: 2.2rem;
    text-transform: uppercase;
    color: var(--mittelblau);
    margin: 0 0 1rem;
}

.scanner3-container .cancel-confirm-dialog p {
    font-family: 'Circular', sans-serif;
    font-size: 1.2rem;
    margin: 0 0 2rem;
    color: var(--mittelblau);
}

.scanner3-container .dialog-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
}

.scanner3-container .dialog-buttons button {
    padding: 16px 28px;
    font-family: 'Staatliches', sans-serif;
    font-size: 1.3rem;
    text-transform: uppercase;
    border-radius: 14px;
    border: none;
    cursor: pointer;
    min-width: 150px;
    transition: transform 0.15s ease;
}

/* Weiter (primär) = Orange, Abbrechen (destruktiv) = Blutorange */
.scanner3-container .dialog-button-no {
    background-color: var(--orange);
    color: white;
}

.scanner3-container .dialog-button-yes {
    background-color: var(--blutorange);
    color: white;
}

/* ===================== SUCCESS / ERROR ===================== */

.scanner3-container .success-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    gap: 0.5rem;
    padding: 2rem 1rem;
}

.scanner3-container .success-check {
    font-size: 4rem;
    color: var(--orange);
}

.scanner3-container .success-message h2 {
    font-family: 'Staatliches', sans-serif;
    font-size: 2.4rem;
    text-transform: uppercase;
    color: var(--mittelblau);
    margin-bottom: 0.5rem;
    text-align: center;
}

.scanner3-container .success-message p {
    font-family: 'Circular', sans-serif;
    font-size: 1.2rem;
    color: var(--mittelblau);
    margin-bottom: 1.5rem;
}

.scanner3-container .success-message .success-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
}

.scanner3-container .success-message .logout-button,
.scanner3-container .success-message .submit-button {
    flex-grow: 0;
    min-width: 240px;
}

.scanner3-container .error-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    gap: 0.5rem;
    padding: 2rem 1rem;
}

.scanner3-container .error-message h1 {
    font-family: 'Staatliches', sans-serif;
    font-size: 2.4rem;
    text-transform: uppercase;
    color: var(--blutorange);
    text-align: center;
    padding: 0;
}

.scanner3-container .error-message p {
    font-family: 'Circular', sans-serif;
    font-size: 1.2rem;
    color: var(--mittelblau);
    margin-bottom: 1.5rem;
    text-align: center;
}

.scanner3-container .error-message .logout-button {
    flex-grow: 0;
    min-width: 240px;
}

/* ===================== TIMEOUT COUNTER ===================== */

.scanner3-container .timeout-counter {
  position: fixed;
  bottom: 20px;
  right: 20px;
  font-family: 'Circular', sans-serif;
  font-size: 0.8rem;
  color: var(--mittelblau);
  background: rgba(255, 255, 255, 0.5);
  padding: 4px 12px;
  border-radius: 20px;
  z-index: 200;
  pointer-events: none;
}

/* ===================== SCROLLBAR ===================== */

.scanner3-container .scrollable-content::-webkit-scrollbar {
  width: 12px;
}

.scanner3-container .scrollable-content::-webkit-scrollbar-track {
  background: var(--blassgruen);
  border-radius: 10px;
}

.scanner3-container .scrollable-content::-webkit-scrollbar-thumb {
  background-color: var(--hellgruen);
  border-radius: 10px;
  border: 3px solid var(--blassgruen);
}
`, "",{"version":3,"sources":["webpack://./src/tools/scanner3/Scanner3.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;;+EAE+E;AAC/E;;;;IAII,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,wDAAwD;IACxD,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;AACf;;AAEA;;;;uDAIuD;AACvD;IACI,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,SAAO;IACP,aAAa;IACb,gBAAgB,EAAE,4DAA4D;AAClF;;AAEA;IACI,YAAY;IACZ,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,aAAa,EAAE,2DAA2D;AAC9E;;AAEA;;IAEI,cAAc,EAAE,2DAA2D;AAC/E;;AAEA,0DAA0D;;AAE1D;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA,uEAAuE;AACvE;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,wBAAwB;IACxB,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;AAChB;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,qDAAqD;EACrD,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iEAAiE;;AAEjE;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,MAAM;AACV;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,4BAA4B;EAC5B,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sEAAsE;IACtE,oBAAoB;AACxB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,4BAA4B;EAC5B,wCAAwC;EACxC,WAAW;EACX,wDAAwD;AAC1D;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAS;IACT,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,mDAAmD;AACvD;;AAEA,yBAAyB;AACzB;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,6BAA6B;AAC7B;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,sCAAsC;IACtC,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,2EAA2E;IAC3E,iBAAiB;AACrB;;AAEA,iEAAiE;AACjE;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,wBAAwB;IACxB,mCAAmC;IACnC,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,kDAAkD;IAClD,aAAa;IACb,mBAAmB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,6EAA6E;EAC7E,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,wBAAwB;EACxB,SAAS;EACT,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB;;;oCAGkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,+EAA+E;EAC/E,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;6EAG6E;AAC7E;EACE,yCAAyC;EACzC,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,0EAA0E;EAC1E,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA,8DAA8D;;AAE9D;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,kEAAkE;AAClE;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,YAAY;AAChB;;AAEA,gEAAgE;;AAEhE;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA,gEAAgE;;AAEhE;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,iBAAiB;EACjB,wBAAwB;EACxB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA,0DAA0D;;AAE1D;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,mCAAmC;AACrC","sourcesContent":["html, body, #root {\n    min-height: 100%;\n    margin: 0;\n}\n\n/* CI: alle Elemente in normaler Schriftstärke.\n   !important, weil JobDisplay.css global geladen wird und\n   gleich benannte Klassen (.job-name etc.) mit font-weight 600 hineinleaken. */\n.scanner3-container,\n.scanner3-container *,\n.touch-drag-ghost,\n.touch-drag-ghost * {\n    font-weight: normal !important;\n}\n\n.scanner3-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: 100dvh;\n    padding: 0 20px 20px;\n    box-sizing: border-box;\n    position: relative;\n    background-color: var(--blassgruen);\n}\n\n.scanner3-container .scanner-content-wrapper {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-start;\n    text-align: center;\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 12px 0 calc(24px + env(safe-area-inset-bottom));\n    overflow: visible;\n    box-sizing: border-box;\n}\n\n.scanner3-container .back-arrow {\n    position: static !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    margin: 8px 0 12px;\n    z-index: 50;\n}\n\n/* ===================== V3 FESTE VIEWPORT-HÖHE =====================\n   Nur Scanner V3 (eindeutige Klasse, damit V1/V2 unberührt bleiben):\n   Der Container füllt exakt den Viewport (position:fixed umgeht das\n   body-Padding/height-Chaos), und NUR die Job-Liste scrollt – der\n   \"Bewerbung absenden\"-Footer bleibt immer sichtbar. */\n.scanner3-container {\n    position: fixed;\n    inset: 0;\n    overflow: hidden;\n}\n\n.scanner3-container .scanner-content-wrapper {\n    min-height: 0;\n}\n\n.scanner3-container .bewerbung-form {\n    height: auto;\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto; /* nur die Schicht-Auswahl scrollt, falls sie zu hoch wird */\n}\n\n.scanner3-container .job-selection-view {\n    height: auto;\n    flex: 1;\n    min-height: 0;\n}\n\n.scanner3-container .scrollable-content {\n    min-height: 0; /* erlaubt dem Flex-Kind zu schrumpfen -> interner Scroll */\n}\n\n.scanner3-container .sticky-header,\n.scanner3-container .sticky-footer {\n    flex: 0 0 auto; /* Kopf & Footer behalten ihre Höhe, schrumpfen nicht weg */\n}\n\n/* ===================== SCAN PAGE ===================== */\n\n.scanner3-container .scan-prompt {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    gap: 0.5rem;\n    padding: 2rem 1rem;\n}\n\n/* Statisches Banner-Logo wie auf der Web-Startseite, etwas kompakter */\n.scanner3-container .scan-logo {\n    width: 100%;\n    max-width: 340px;\n    height: auto;\n    aspect-ratio: 363 / 276;\n    object-fit: contain;\n    margin-bottom: 1rem;\n}\n\n.scanner3-container .scan-prompt h1 {\n    font-family: 'Staatliches', sans-serif;\n    font-size: 3rem;\n    color: var(--mittelblau);\n    text-transform: uppercase;\n    margin: 0;\n    padding: 0;\n    text-align: center;\n}\n\n.scanner3-container .scan-subtitle {\n    font-family: 'Circular', sans-serif;\n    font-size: 1.3rem;\n    color: var(--mittelblau);\n    margin: 0 0 1rem;\n}\n\n.scanner3-container .scanner-icon {\n    font-size: 140px;\n    color: var(--orange);\n    opacity: 0.9;\n}\n\n/* ===================== SHIFT SELECTION ===================== */\n\n.scanner3-container .einheiten-grid {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 24px;\n  width: 100%;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  padding: 2rem;\n}\n\n.scanner3-container .einheiten-day-group {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 12px;\n}\n\n.scanner3-container .einheiten-day-group h4 {\n  margin-bottom: 8px;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.3rem;\n  text-transform: uppercase;\n  color: var(--mittelblau);\n  text-align: center;\n}\n\n.scanner3-container .einheiten-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.scanner3-container .einheit-button {\n  padding: 32px 28px;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.5rem;\n  text-transform: uppercase;\n  text-align: center;\n  background-color: var(--orange);\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n  color: var(--weiss);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.scanner3-container .einheit-button.inactive {\n  background-color: #e3e3d3;\n  color: #a7ad94;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* ===================== APPLICATION FORM ===================== */\n\n.scanner3-container .bewerbung-form {\n    width: 100%;\n    height: 100%;\n    max-width: 1200px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0;\n}\n\n.scanner3-container .bewerbung-form > h1 {\n    font-family: 'Staatliches', sans-serif;\n    font-size: 2.4rem;\n    color: var(--mittelblau);\n    text-transform: uppercase;\n    text-align: center;\n    padding: 0.5rem 0 1rem;\n    margin: 0;\n    width: 100%;\n}\n\n.scanner3-container .bewerbung-form > p {\n    font-family: 'Circular', sans-serif;\n    font-size: 1.2rem;\n    color: var(--mittelblau);\n}\n\n.scanner3-container .job-selection-view {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n\n.scanner3-container .sticky-header {\n  padding: 0.5rem 1rem 0.75rem 1rem;\n  background-color: var(--blassgruen);\n  border-radius: 0 0 20px 20px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.08);\n  z-index: 10;\n}\n\n.scanner3-container .scrollable-content {\n  flex-grow: 1;\n  overflow-y: auto;\n  position: relative;\n  padding: 1rem;\n}\n\n.scanner3-container .scrollable-content::after {\n    content: '';\n    position: sticky;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 60px;\n    background: linear-gradient(to bottom, transparent, var(--blassgruen));\n    pointer-events: none;\n}\n\n.scanner3-container .loading-text {\n  font-family: 'Circular', sans-serif;\n  font-size: 1.5rem;\n  padding: 3rem;\n  color: var(--mittelblau);\n}\n\n.scanner3-container .sticky-footer {\n  padding: 1rem;\n  background-color: var(--blassgruen);\n  border-radius: 20px 20px 0 0;\n  box-shadow: 0 -4px 10px rgba(0,0,0,0.08);\n  z-index: 10;\n  padding-bottom: calc(1rem + env(safe-area-inset-bottom));\n}\n\n.scanner3-container .form-actions {\n    display: flex;\n    gap: 1rem;\n    margin: 0;\n    width: 100%;\n    padding: 0;\n    box-sizing: border-box;\n    flex-wrap: wrap;\n}\n\n/* Primary / secondary buttons */\n.scanner3-container .submit-button, .scanner3-container .logout-button {\n    flex-grow: 1;\n    padding: 18px 24px;\n    font-family: 'Staatliches', sans-serif;\n    font-size: 1.5rem;\n    text-transform: uppercase;\n    border: none;\n    border-radius: 16px;\n    cursor: pointer;\n    transition: transform 0.15s ease, opacity 0.2s ease;\n}\n\n/* Akzeptfarbe = Orange */\n.scanner3-container .submit-button {\n    background-color: var(--orange);\n    color: var(--weiss);\n    box-shadow: 0 4px 12px rgba(243, 146, 0, 0.35);\n}\n\n.scanner3-container .submit-button:disabled {\n    background-color: rgba(243, 146, 0, 0.4);\n    color: #fff;\n    cursor: not-allowed;\n    box-shadow: none;\n    transform: none;\n}\n\n/* Sekundär = blau, outline */\n.scanner3-container .logout-button {\n    background-color: transparent;\n    color: var(--mittelblau);\n    border: 2px solid var(--mittelblau);\n}\n\n.scanner3-container .einheit-selection-header {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n    width: 100%;\n    min-height: 52px;\n}\n\n.scanner3-container .einheit-selection-header h2 {\n    margin: 0;\n    font-family: 'Staatliches', sans-serif;\n    font-size: 1.8rem;\n    text-transform: uppercase;\n    color: var(--mittelblau);\n    text-align: center;\n    /* full-width centred; padding keeps long titles clear of the back button */\n    padding: 0 3.5rem;\n}\n\n/* Absolutely positioned so it never shifts the centred heading */\n.scanner3-container .back-to-einheit-button {\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    background: var(--weiss);\n    border: 2px solid var(--mittelblau);\n    color: var(--mittelblau);\n    font-size: 1.6rem;\n    cursor: pointer;\n    padding: 0.5rem 1rem;\n    line-height: 1;\n    border-radius: 14px;\n    transition: background-color 0.2s, transform 0.15s;\n    display: flex;\n    align-items: center;\n}\n\n.scanner3-container .status-bar {\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0;\n}\n\n.scanner3-container .status-bar p {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.2rem;\n}\n\n/* ===================== JOB TILES ===================== */\n\n.scanner3-container .job-tiles-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.25rem;\n  width: 100%;\n  padding-bottom: 3rem;\n  box-sizing: border-box;\n}\n\n.scanner3-container .job-tile {\n  position: relative;\n  background-color: var(--weiss);\n  border: 3px solid transparent;\n  border-radius: 18px;\n  padding: 1.25rem 1rem;\n  min-height: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n  text-align: center;\n}\n\n/* Ausgewählt = oranger Akzent */\n.scanner3-container .job-tile.selected {\n  border-color: var(--orange);\n  background-color: rgba(243, 146, 0, 0.12);\n  box-shadow: 0 6px 16px rgba(243, 146, 0, 0.3);\n  transform: translateY(-2px);\n}\n\n.scanner3-container .job-tile.disabled {\n  background-color: #f0f1e8;\n  opacity: 0.5;\n  cursor: not-allowed;\n  border-color: transparent;\n  transform: none;\n  box-shadow: none;\n}\n\n.scanner3-container .job-tile .job-name {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.6rem;\n  text-transform: uppercase;\n  margin: 0 0 0.5rem;\n  color: var(--mittelblau);\n}\n\n.scanner3-container .job-tile .job-slots {\n  font-family: 'Circular', sans-serif;\n  font-size: 1rem;\n  color: var(--mittelblau);\n  margin: 0;\n  background-color: var(--hellgruen);\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n}\n\n/* ===================== PRIORITY SLOTS ===================== */\n\n.scanner3-container .priority-slots-header {\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n\n.scanner3-container .priority-slots-header h3 {\n  margin: 0 0 0.25rem 0;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.6rem;\n  line-height: 1.1;\n  text-transform: uppercase;\n  color: var(--mittelblau);\n  text-align: center;\n}\n\n.scanner3-container .priority-slots-header .drag-hint {\n  font-family: 'Circular', sans-serif;\n  text-transform: none;\n  font-size: 1rem;\n  color: var(--mittelblau);\n}\n\n.scanner3-container .priority-slots-header p {\n  margin: 0;\n  font-family: 'Circular', sans-serif;\n  font-size: 1.1rem;\n  color: var(--mittelblau);\n}\n\n.scanner3-container .priority-slots-container {\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background-color: var(--hellgruen);\n  border-radius: 18px;\n  margin-bottom: 0.6rem;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scanner3-container .priority-slot {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem;\n  border-radius: 14px;\n  min-height: 64px;\n  transition: transform 120ms cubic-bezier(0.25, 0.8, 0.25, 1),\n              background-color 120ms ease-out,\n              box-shadow 120ms ease-out,\n              opacity 120ms ease-out;\n  position: relative;\n  will-change: transform;\n  /* Claim the touch gesture so the browser never tries to scroll/zoom mid-drag */\n  touch-action: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.scanner3-container .priority-slot.empty {\n  background-color: rgba(255, 255, 255, 0.55);\n  border: 2px dashed var(--primary-dark);\n  justify-content: center;\n  color: var(--primary-dark);\n}\n\n/* Gefüllt = oranger Akzent */\n.scanner3-container .priority-slot.filled {\n  background-color: var(--weiss);\n  border: 2px solid var(--orange);\n  cursor: grab;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\n}\n\n.scanner3-container .priority-slot.filled:active {\n  cursor: grabbing;\n}\n\n.scanner3-container .priority-slot-number {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.4rem;\n  color: var(--primary-dark);\n  margin-right: 0.5rem;\n}\n\n.scanner3-container .priority-slot.filled .priority-slot-number {\n  color: var(--orange);\n}\n\n.scanner3-container .priority-slot-name {\n  flex-grow: 1;\n  text-align: center;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.2rem;\n  color: var(--mittelblau);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.scanner3-container .priority-slot.empty .priority-slot-name {\n  color: var(--primary-dark);\n}\n\n.scanner3-container .drag-handle {\n  font-size: 1.5rem;\n  color: var(--orange);\n  cursor: grab;\n  margin-left: 0.5rem;\n}\n\n/* The lifted card is the floating ghost; the source slot becomes a calm,\n   same-size placeholder so the ghost can snap back into it seamlessly.\n   We dim the whole slot (instead of hiding its children) so that even if a\n   drag were ever to end unexpectedly, the tile can never become invisible. */\n.scanner3-container .priority-slot.dragging {\n  background-color: rgba(243, 146, 0, 0.08);\n  border: 2px dashed var(--orange);\n  box-shadow: none;\n  opacity: 0.4;\n  transform: none;\n}\n\n/* Floating clone that follows the finger. transition:none keeps movement\n   locked 1:1 to the finger (the clone inherits .priority-slot's transition\n   otherwise); the drop-snap sets its own transition inline. */\n.touch-drag-ghost {\n  box-shadow: 0 12px 24px rgba(72, 80, 40, 0.28), 0 6px 8px rgba(0,0,0,0.18);\n  transition: none;\n  will-change: transform;\n}\n\n.scanner3-container .priority-badge {\n  position: absolute;\n  top: -10px;\n  left: -10px;\n  background-color: var(--orange);\n  color: white;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: 'Staatliches', sans-serif;\n  font-size: 1.4rem;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.25);\n}\n\n/* ===================== CANCEL DIALOG ===================== */\n\n.scanner3-container .cancel-confirm-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(72, 80, 40, 0.55);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.scanner3-container .cancel-confirm-dialog {\n    background-color: white;\n    padding: 2.5rem;\n    border-radius: 24px;\n    box-shadow: 0 8px 28px rgba(0,0,0,0.25);\n    text-align: center;\n    width: 90%;\n    max-width: 500px;\n}\n\n.scanner3-container .cancel-confirm-dialog h2 {\n    font-family: 'Staatliches', sans-serif;\n    font-size: 2.2rem;\n    text-transform: uppercase;\n    color: var(--mittelblau);\n    margin: 0 0 1rem;\n}\n\n.scanner3-container .cancel-confirm-dialog p {\n    font-family: 'Circular', sans-serif;\n    font-size: 1.2rem;\n    margin: 0 0 2rem;\n    color: var(--mittelblau);\n}\n\n.scanner3-container .dialog-buttons {\n    display: flex;\n    gap: 1rem;\n    justify-content: center;\n}\n\n.scanner3-container .dialog-buttons button {\n    padding: 16px 28px;\n    font-family: 'Staatliches', sans-serif;\n    font-size: 1.3rem;\n    text-transform: uppercase;\n    border-radius: 14px;\n    border: none;\n    cursor: pointer;\n    min-width: 150px;\n    transition: transform 0.15s ease;\n}\n\n/* Weiter (primär) = Orange, Abbrechen (destruktiv) = Blutorange */\n.scanner3-container .dialog-button-no {\n    background-color: var(--orange);\n    color: white;\n}\n\n.scanner3-container .dialog-button-yes {\n    background-color: var(--blutorange);\n    color: white;\n}\n\n/* ===================== SUCCESS / ERROR ===================== */\n\n.scanner3-container .success-message {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    gap: 0.5rem;\n    padding: 2rem 1rem;\n}\n\n.scanner3-container .success-check {\n    font-size: 4rem;\n    color: var(--orange);\n}\n\n.scanner3-container .success-message h2 {\n    font-family: 'Staatliches', sans-serif;\n    font-size: 2.4rem;\n    text-transform: uppercase;\n    color: var(--mittelblau);\n    margin-bottom: 0.5rem;\n    text-align: center;\n}\n\n.scanner3-container .success-message p {\n    font-family: 'Circular', sans-serif;\n    font-size: 1.2rem;\n    color: var(--mittelblau);\n    margin-bottom: 1.5rem;\n}\n\n.scanner3-container .success-message .success-actions {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.scanner3-container .success-message .logout-button,\n.scanner3-container .success-message .submit-button {\n    flex-grow: 0;\n    min-width: 240px;\n}\n\n.scanner3-container .error-message {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    gap: 0.5rem;\n    padding: 2rem 1rem;\n}\n\n.scanner3-container .error-message h1 {\n    font-family: 'Staatliches', sans-serif;\n    font-size: 2.4rem;\n    text-transform: uppercase;\n    color: var(--blutorange);\n    text-align: center;\n    padding: 0;\n}\n\n.scanner3-container .error-message p {\n    font-family: 'Circular', sans-serif;\n    font-size: 1.2rem;\n    color: var(--mittelblau);\n    margin-bottom: 1.5rem;\n    text-align: center;\n}\n\n.scanner3-container .error-message .logout-button {\n    flex-grow: 0;\n    min-width: 240px;\n}\n\n/* ===================== TIMEOUT COUNTER ===================== */\n\n.scanner3-container .timeout-counter {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.8rem;\n  color: var(--mittelblau);\n  background: rgba(255, 255, 255, 0.5);\n  padding: 4px 12px;\n  border-radius: 20px;\n  z-index: 200;\n  pointer-events: none;\n}\n\n/* ===================== SCROLLBAR ===================== */\n\n.scanner3-container .scrollable-content::-webkit-scrollbar {\n  width: 12px;\n}\n\n.scanner3-container .scrollable-content::-webkit-scrollbar-track {\n  background: var(--blassgruen);\n  border-radius: 10px;\n}\n\n.scanner3-container .scrollable-content::-webkit-scrollbar-thumb {\n  background-color: var(--hellgruen);\n  border-radius: 10px;\n  border: 3px solid var(--blassgruen);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
